import { useLayoutEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { company } from '~/company/Company';
import { userStore } from '~/stores';
import { getCookieValue, setCookie } from '~/utils/cookies';

const rtlLangs = ['ar', 'he', 'fa', 'ur', 'sd', 'hw', 'ps', 'ug'];

export const useLang = () => {
  const { i18n } = useTranslation();

  const changeLang = (lang: string) => {
    userStore.setLang(lang);
    i18n.changeLanguage(lang);
    userStore.setDir(rtlLangs.includes(lang) ? 'rtl' : 'ltr');
  };

  const setNavigatorLang = () => {
    const browserLang = navigator.language;
    const langGroup = browserLang.split('-')[0] ?? company.config.lang;
    const checkedLang = company.config.langs.includes(langGroup)
      ? langGroup
      : company.config.lang;
    changeLang(checkedLang);
    setCookie('lang', checkedLang, { 'max-age': 2678400 });
  };

  useLayoutEffect(() => {
    if (company.forceLanguage) {
      changeLang(company.forceLanguage);
      setCookie('lang', company.forceLanguage, { 'max-age': 2678400 });
      return;
    }

    const cookieLang = getCookieValue('lang');

    if (cookieLang && company.config.langs?.includes(cookieLang)) {
      changeLang(cookieLang);
    } else if (company.preferCompanyLanguage) {
      changeLang(company.config.lang);
      setCookie('lang', company.config.lang, { 'max-age': 2678400 });
    } else {
      setNavigatorLang();
    }
  }, []);

  const setLanguage = (lang: string) => {
    setCookie('lang', lang, { 'max-age': 2678400 });
    window.location.reload();
  };

  return { setLanguage };
};
